import { FormLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { minimalLabelTheme } from '@/app/theme';
import { useGetTaskCategoriesQuery } from '@/features/engagements/engagementsApi';

export const CategorySelect = ({ category, disabled, setCategory, minimal, ...props }) => {
	const { data: categories = [] } = useGetTaskCategoriesQuery();

	return (
		<>
			<FormLabel sx={minimal ? minimalLabelTheme : undefined}>{'Category'}</FormLabel>
			<Select
				name='category'
				value={category ?? ''}
				disabled={disabled}
				onChange={(e) => setCategory(e.target.value || null)}
				fullWidth={true}
				displayEmpty
				{...props}
			>
				<MenuItem value=''>NONE</MenuItem>

				{categories.map((cat) => (
					<MenuItem key={`category-selection-${cat.id}`} value={cat.value}>
						{cat.label}
					</MenuItem>
				))}
			</Select>
		</>
	);
};
